import moment from 'moment-timezone';

export const getAgeFromDate = (date: string | Date) =>
  moment().diff(moment(new Date(date)), 'y');

/**
 * Calculate the number of days from a past date to today.
 */
export const getNumberOfDaysToNow = (dateBeforeNowString: string) => {
  const difference =
    new Date(Date.now()).getTime() - new Date(dateBeforeNowString).getTime();

  if (Math.floor(difference) > 0) {
    const numberOfDays = difference / (1000 * 60 * 60 * 24);

    return numberOfDays;
  }

  return 0;
};
